// https://ufcfightpass.smalyu.ru/api/v1/ - test server
// https://ufcfightpass.ru/api/v1/ - production server

const siteUrl = process.env.REACT_APP_BACKEND_URL || "https://ufcfightpass.ru"
const siteRegion = process.env.REACT_APP_SITE_REGION || "ru"
const siteCurrency = {ru: "RUB", uz: "UZS"}[siteRegion]

const _apiURL = `${siteUrl}/api/v1/`;

// pk_7ac63433084f86b2bafcb5880e1a6 - test public id
// pk_28c66dbb88a749098f33d884e2723 - production public id

const _publicId = 'pk_28c66dbb88a749098f33d884e2723';

const DEBUG = false;

console.log('Config vars:', {siteUrl, siteRegion, siteCurrency, _apiURL, DEBUG});

export {_publicId, DEBUG, siteUrl, siteRegion, siteCurrency };
export default _apiURL;

